/** @format */

import {
  PercentagePropsTypes,
  questionIdHashObj,
} from "../PercentagePropsTypes";
import { useContext } from "react";
import { CheckResponsiveContext } from "../../../Context/CheckResponsiveContext";
import { ActionKind } from "../../../SupplierView/SupplierViewPropsTypes";
import Percentage from "../Components/Percentage";
import PercentageMobileView from "../Components/PercentageMobileView";
function NumberContainer({
  surveyAnswers,
  setSurveyAnswers,
  questionId,
  isPreview,
  questionObjVariable,
  surveyAnswersInfo,
  dispatch,
  reducerState,
}: PercentagePropsTypes) {
  const { isMobile } = useContext(CheckResponsiveContext);
  const handleChangeInputNumber: PercentagePropsTypes["handleChangeInputNumber"] =
    (questionId, e) => {
      const value = e.target.valueAsNumber;
      let questionIdHashObj = {} as questionIdHashObj;
      questionIdHashObj[questionId] =
        questionObjVariable![questionId]?.numberInfo!;
      if (isNaN(value)) {
        dispatch!({
          type: ActionKind.SET_NUMBER_QUES_ID_HASH,
          payload: questionId,
        });
        dispatch!({
          type: ActionKind.SET_VALID_NUMBER_ERROR_MSG,
          payload: {
            questionId: questionId,
            errorMessage: "Enter a valid number to enable submitting",
          },
        });
      } else {
        dispatch!({
          type: ActionKind.REMOVE_QUES_ID_FROM_NUM_HASH,
          payload: questionId,
        });
        dispatch!({
          type: ActionKind.SET_VALID_NUMBER_ERROR_MSG,
          payload: {
            questionId: questionId,
            errorMessage: "",
          },
        });
      }
      //immer method
      setSurveyAnswers((draft: PercentagePropsTypes["surveyAnswers"]) => {
        draft[questionId] = draft[questionId] || {};
        if (isNaN(value)) {
          if (
            draft[questionId].comment?.length ||
            draft[questionId].uploads?.length
          ) {
            delete draft[questionId]["val"];
            delete draft[questionId]["score"];
            delete draft[questionId]["emissionFactorConvertedValue"];
          } else {
            delete draft[questionId];
          }
        } else {
          draft[questionId]["val"] = value;
          if (questionObjVariable?.[questionId]?.emissionFactor?.enabled) {
            draft[questionId]["emissionFactorConvertedValue"] =
              value * questionObjVariable?.[questionId].emissionFactor!.value;
          }
          if (surveyAnswersInfo.surveyInfo.isScoreEnable) {
            for (const [index, numberInfo] of questionIdHashObj[
              questionId
            ].entries()) {
              if (draft[questionId].val <= numberInfo?.upperLimit) {
                draft[questionId].score = numberInfo?.weightage;
                break;
              } else if (
                index === questionIdHashObj[questionId].length - 1 &&
                draft[questionId].val === numberInfo?.upperLimit
              ) {
                draft[questionId].score = numberInfo?.weightage;
              } else {
                draft[questionId].score = 0;
              }
            }
          }
        }
      });
    };
  return (
    <>
      {isMobile ? (
        <PercentageMobileView
          handleChangeInputNumber={handleChangeInputNumber}
          isPreview={isPreview}
          surveyAnswers={surveyAnswers}
          questionId={questionId}
          surveyAnswersInfo={surveyAnswersInfo}
        />
      ) : (
        <Percentage
          handleChangeInputNumber={handleChangeInputNumber}
          isPreview={isPreview}
          surveyAnswers={surveyAnswers}
          questionId={questionId}
          surveyAnswersInfo={surveyAnswersInfo}
          reducerState={reducerState}
        />
      )}
    </>
  );
}

export default NumberContainer;
